import { combine, createEvent, createStore, restore, sample } from 'effector'
import { createGate } from 'effector-react'
import { fx } from 'src/libs'
import {
  NotificationPayload,
  showNotification,
} from 'src/features/notifications'
import { getBudgetErrorNotification } from 'src/pages/budget/errorNotification'
import {
  STATUS,
  STATUS_MAP_NAME,
  STATUS_PERIOD_LABELS,
} from 'src/pages/budget/const'
import {
  addArticleItemFx,
  getArticleListFx,
  getTeamListFx,
} from 'src/pages/budget/model'
import {
  RequestPayload,
  ApiResponseContext,
  Article,
  BudgetListResponse,
  BudgetPeriodState,
  BudgetRequest,
  CommentType,
  Period,
  ModalRequests,
  ModalRequestApprove,
  RequestCommentPayload,
  RequestCommentStore,
  Currency,
  ActionStep,
  BatchDecisionItem,
  BatchDecisionResult,
  RejectSeo,
} from 'src/pages/budget/budgetRequests/types'
import {
  filterBudgetList,
  getBudgetPeriodState,
  sortBudgetRequests,
} from 'src/pages/budget/utils'

import dayjs from 'dayjs'
import { capitalize } from 'lodash'
import { TeamsResponse } from 'src/pages/budget/model'
import { TStatusPeriod } from 'src/pages/budget/types'

dayjs.locale('ru')

export const BudgetPeriodGate = createGate()
export const CreateContextGate = createGate()
export const EditRequestGate = createGate<{ id: string | undefined }>()
export const CommentsGate = createGate<{ id: number }>()
export const CurrencyGate = createGate()

export const changeCurrentBudgetPeriodId = createEvent<{ id: number }>()
export const resetCurrentRequest = createEvent()

export const openModalRequestView = createEvent<
  ModalRequests & { mode: 'own' | 'forApprove'; periodStatus?: TStatusPeriod }
>()
export const closeModalRequestView = createEvent()

export const openModalRequestsDelete = createEvent<ModalRequests>()
export const closeModalRequestsDelete = createEvent()

export const openModalRequestsToSubmit = createEvent<ModalRequests>()
export const closeModalRequestsToSubmit = createEvent()

export const openModalRequestsApprove = createEvent<ModalRequestApprove>()
export const closeModalRequestsApprove = createEvent()

export const openModalRequestsReject = createEvent<ModalRequestApprove>()
export const closeModalRequestsReject = createEvent()

export const openModalRequestComment = createEvent<RequestCommentStore>()
export const closeModalRequestComment = createEvent()

export const openModalRequestsCopy = createEvent<ModalRequests>()
export const closeModalRequestsCopy = createEvent()

export const openModalRequestsRejectSeo = createEvent<ModalRequests>()
export const closeModalRequestsRejectSeo = createEvent()

export const submitRequestsDelete = createEvent<ModalRequests>()
export const submitRequestsToSubmit = createEvent<ModalRequests>()
export const submitRequestsUpdate = createEvent<ModalRequests>()
export const submitRequestsReturnToDraft = createEvent<ModalRequests>()
export const submitRequestsApprove = createEvent<ActionStep>()
export const submitRequestsReject = createEvent<
  ActionStep & { comment: string }
>()
export const submitRequestsApproveReject = createEvent<RejectSeo>()
export const submitRequestEarlyPayment = createEvent<{ id: number }>()
export const reloadBudgetRequests = createEvent()

export const filtersChangedBudgetListTeam = createEvent<Record<string, any>>()
export const filtersChangedBudgetListOwn = createEvent<Record<string, any>>()
export const filtersChangedBudgetListOwnApprove =
  createEvent<Record<string, any>>()
export const filtersChangedBudgetListOwnReject =
  createEvent<Record<string, any>>()
export const filtersChangedBudgetListUrgent = createEvent<Record<string, any>>()

export const getTeamTreeFx = fx<void, TeamsResponse>({
  method: 'GET',
  url: '/budget/team/hierarchy',
})

export const getBudgetPeriodListFx = fx<
  void,
  { items: Period[]; total: number }
>({
  method: 'GET',
  url: '/budget/budget_period',
})

export const getBudgetPeriodListForContextFx = fx<
  void,
  { items: Period[]; total: number }
>({
  method: 'GET',
  url: '/budget/budget_period',
})

export const changeStatusBudgetPeriodFx = fx<{ status: TStatusPeriod }, Period>(
  {
    method: 'POST',
  },
)

export const createPeriodFx = fx<{ period: string }, Period>({
  method: 'POST',
  url: '/budget/budget_period',
})

export const getBudgetRequestByIdFx = fx<{ id: string }, BudgetRequest>({
  method: 'GET',
})

export const getBudgetListTeamFx = fx<any, BudgetListResponse>({
  method: 'GET',
  url: '/budget/budget_request/approval_list',
})

export const getBudgetListOwnFx = fx<any, BudgetListResponse>({
  method: 'GET',
  url: '/budget/budget_request/my_list',
})

export const getRequestContextFx = fx<any, ApiResponseContext>({
  method: 'GET',
  url: '/budget/users/context',
})

export const createRequestFx = fx<RequestPayload, BudgetRequest>({
  method: 'POST',
  url: '/budget/budget_request',
})

export const updateRequestFx = fx<Partial<RequestPayload>, BudgetRequest>({
  method: 'PUT',
})
export const enableEarlyPaymentFx = fx<
  { isEarlyPayment: true },
  BudgetRequest
>({ method: 'PUT' })

export const deleteRequestsFx = fx<{ id: string }, any>({
  method: 'DELETE',
})

export const returnToDraftRequestFx = fx<
  {
    url: string
    id: number
  },
  BudgetRequest
>({
  method: 'POST',
})

export const submitRequestFx = fx<
  {
    url: string
    id: number
  },
  BudgetRequest
>({
  method: 'POST',
})

export const copyBudgetRequestFx = fx<{ budgetPeriodId: number }, BudgetRequest>(
  { method: 'POST' },
)

export const approveRequestsFx = fx<ActionStep, BudgetRequest>({
  method: 'POST',
})

export const rejectRequestsFx = fx<{ comment: string }, BudgetRequest>({
  method: 'POST',
})
export const decideRequestsBatchFx = fx<
  { items: BatchDecisionItem[]; comment?: string },
  BatchDecisionResult
>({ method: 'POST' })
//seo
export const rejectApproveRequestsFx = fx<{ comment: string }, BudgetRequest>({
  method: 'POST',
})

export const postCommentRequestsFx = fx<RequestCommentPayload, any>({
  method: 'POST',
  url: '/comment',
})

export const getCommentsRequestsFx = fx<{ id: number }, CommentType[]>({
  method: 'GET',
  url: '/comment',
})

export const getCurrenciesFx = fx<void, Currency[]>({
  method: 'GET',
  url: `/budget/currency_list`,
})

export const $budgetPeriods = createStore<BudgetPeriodState>({
  byPeriod: new Map(),
  byId: new Map(),
  currentPeriodId: null,
  segmentedPeriodOptions: [],
})
  .on(getBudgetPeriodListFx.doneData, (_, res) => {
    return getBudgetPeriodState(res.body.items)
  })
  .on(changeCurrentBudgetPeriodId, (state, { id }) => ({
    ...state,
    currentPeriodId: id,
  }))

export const $budgetPeriodList = createStore<Period[]>([]).on(
  getBudgetPeriodListForContextFx.doneData,
  (_, res) => {
    return res.body.items
  },
)

export const $budgetPeriodOptions = combine($budgetPeriods, (bp) => {
  return Array.from(bp.byId.values()).map((item) => ({
    label: capitalize(
      dayjs(item.periodFormatted, 'YYYY-MM').format('MMMM YYYY'),
    ),
    value: item.id,
  }))
})

//для редактирования /edit/id
export const $currentRequest = createStore<BudgetRequest | null>(null)
  .on(getBudgetRequestByIdFx.doneData, (_, { body }) => body)
  .reset(resetCurrentRequest)

export const $budgetListTeamAll = createStore<BudgetRequest[] | null>(null)
  .on(getBudgetListTeamFx.doneData, (_, res) => res.body.items)
  .reset(changeCurrentBudgetPeriodId)

export const $budgetListOwnAll = createStore<BudgetRequest[] | null>(null)
  .on(getBudgetListOwnFx.doneData, (_, res) => res.body.items)
  .reset(changeCurrentBudgetPeriodId)

export const $budgetListUrgent = combine(
  $budgetListTeamAll,
  $budgetListOwnAll,
  (teamItems, ownItems) => {
    if (teamItems === null && ownItems === null) return null

    return sortBudgetRequests(
      [...(teamItems ?? []), ...(ownItems ?? [])].filter(
        (it) => it.isEarlyPayment,
      ),
    )
  },
)

export const $budgetListTeam = combine($budgetListTeamAll, (items) =>
  items === null
    ? null
    : sortBudgetRequests(items.filter((it) => !it.isEarlyPayment)),
)

export const $budgetListOwn = combine($budgetListOwnAll, (items) =>
  items === null
    ? null
    : sortBudgetRequests(
        items.filter(
          (it) =>
            !it.isEarlyPayment &&
            (it.status === STATUS.DRAFT ||
              it.status === STATUS.SUBMITTED ||
              it.status === STATUS.IN_REVIEW),
        ),
      ),
)

export const $budgetListOwnApprove = combine($budgetListOwnAll, (items) =>
  items === null
    ? null
    : items.filter(
        (it) =>
          it.status === STATUS.APPROVED ||
          it.status === STATUS.PENDING_PAYMENT ||
          it.status === STATUS.PARTIAL_PAYMENT ||
          it.status === STATUS.PAID,
      ),
)

export const $budgetListOwnReject = combine($budgetListOwnAll, (items) =>
  items === null ? null : items.filter((it) => it.status === STATUS.REJECTED),
)

export const $filtersTeam = createStore<Record<string, any>>({
  status: [STATUS.SUBMITTED],
}).on(filtersChangedBudgetListTeam, (_, filters) => filters)

export const $filtersOwn = createStore<Record<string, any>>({}).on(
  filtersChangedBudgetListOwn,
  (_, filters) => filters,
)

export const $filtersOwnApprove = createStore<Record<string, any>>({}).on(
  filtersChangedBudgetListOwnApprove,
  (_, filters) => filters,
)

export const $filtersOwnReject = createStore<Record<string, any>>({}).on(
  filtersChangedBudgetListOwnReject,
  (_, filters) => filters,
)

export const $filtersUrgent = createStore<Record<string, any>>({}).on(
  filtersChangedBudgetListUrgent,
  (_, filters) => filters,
)

export const $filteredBudgetListTeam = combine(
  $budgetListTeam,
  $filtersTeam,
  (list, filters) => {
    if (list === null) return null
    return filterBudgetList(list, filters)
  },
)

export const $filteredBudgetListOwn = combine(
  $budgetListOwn,
  $filtersOwn,
  (list, filters) => {
    if (list === null) return null
    return filterBudgetList(list, filters)
  },
)

export const $filteredBudgetListOwnApprove = combine(
  $budgetListOwnApprove,
  $filtersOwnApprove,
  (list, filters) => {
    if (list === null) return null
    return filterBudgetList(list, filters)
  },
)

export const $filteredBudgetListOwnReject = combine(
  $budgetListOwnReject,
  $filtersOwnReject,
  (list, filters) => {
    if (list === null) return null
    return filterBudgetList(list, filters)
  },
)

export const $filteredBudgetListUrgent = combine(
  $budgetListUrgent,
  $filtersUrgent,
  (list, filters) => {
    if (list === null) return null
    return filterBudgetList(list, filters)
  },
)

export const $accessibleArticles = createStore<Article[]>([]).on(
  getArticleListFx.doneData,
  (_, res) => res.body.items.map((it) => ({ ...it, id: it.articleId })),
)

export const $teamOptions = createStore<{ value: number; label: string }[]>(
  [],
).on(getRequestContextFx.doneData, (_, res) => {
  return res.body.teams
    .filter((team) => team.permissions.includes('submit'))
    .map((team) => ({ value: team.teamId, label: team.teamName }))
})

export const $defaultTeamId = createStore<number | null>(null).on(
  getRequestContextFx.doneData,
  (_, res) => {
    if (res.body.teams.length !== 1) return null
    return res.body.teams[0].teamId
  },
)

export const $modalRequestView = createStore<
  | (ModalRequests & {
      mode: 'own' | 'forApprove'
      periodStatus?: TStatusPeriod
    })
  | null
>(null)
  .on(openModalRequestView, (_, payload) => payload)
  .reset(closeModalRequestView)

export const $modalRequestsDelete = createStore<ModalRequests | null>(null)
  .on(openModalRequestsDelete, (_, payload) => payload)
  .reset(closeModalRequestsDelete)

export const $modalRequestsToSubmit = createStore<ModalRequests | null>(null)
  .on(openModalRequestsToSubmit, (_, payload) => payload)
  .reset(closeModalRequestsToSubmit)

export const $modalRequestsApprove = createStore<ModalRequestApprove | null>(
  null,
)
  .on(openModalRequestsApprove, (_, payload) => payload)
  .reset(closeModalRequestsApprove)

export const $modalRequestsReject = createStore<ModalRequestApprove | null>(
  null,
)
  .on(openModalRequestsReject, (_, payload) => payload)
  .reset(closeModalRequestsReject)

export const $modalRequestsCopy = createStore<ModalRequests | null>(null)
  .on(openModalRequestsCopy, (_, payload) => payload)
  .reset(closeModalRequestsCopy)

export const $modalRequestComment = createStore<RequestCommentStore | null>(
  null,
)
  .on(openModalRequestComment, (_, payload) => payload)
  .reset(closeModalRequestComment)

export const $modalRequestRejectSeo = createStore<ModalRequests | null>(null)
  .on(openModalRequestsRejectSeo, (_, payload) => payload)
  .reset(closeModalRequestsRejectSeo)

export const $commentList = createStore<CommentType[]>([])
  .on(getCommentsRequestsFx.doneData, (_, { body }) => body)
  .reset(closeModalRequestView)

export const $currencies = restore<Currency[]>(
  getCurrenciesFx.doneData.map((a) => a.body),
  [],
)

sample({
  clock: [
    BudgetPeriodGate.open,
    createPeriodFx.done,
    changeStatusBudgetPeriodFx.done,
  ],
  fn: () => ({}),
  target: [getTeamListFx, getBudgetPeriodListFx], // ceoTeam
})

sample({
  clock: CreateContextGate.open,
  fn: () => ({}),
  target: [
    getRequestContextFx,
    getBudgetPeriodListForContextFx,
    getArticleListFx,
    getTeamListFx, // ceoTeam
  ],
})

sample({
  clock: EditRequestGate.open,
  fn: ({ id }) => {
    return {
      query: {
        populate: JSON.stringify(['User', 'User.createdBy']),
      },
      url: `/budget/budget_request/${id}`,
    }
  },
  target: getBudgetRequestByIdFx,
})

sample({
  clock: CommentsGate.open,
  fn: ({ id }) => ({
    query: {
      where: JSON.stringify({ entityType: 'budget_request', entityId: id }),
      populate: JSON.stringify(['User', 'User.createdBy']),
    },
  }),
  target: getCommentsRequestsFx,
})

sample({
  clock: CurrencyGate.open,
  fn: () => ({}),
  target: getCurrenciesFx,
})

sample({
  clock: [CreateContextGate.close, EditRequestGate.close],
  target: resetCurrentRequest,
})

sample({
  clock: $budgetPeriods.updates,
  filter: ({ currentPeriodId }) => Boolean(currentPeriodId),
  fn: ({ currentPeriodId }) => ({
    query: {
      where: JSON.stringify({ periodId: currentPeriodId }),
      populate: JSON.stringify(['User', 'User.createdBy']),
    },
  }),
  target: [getBudgetListTeamFx, getBudgetListOwnFx],
})

sample({
  clock: reloadBudgetRequests,
  source: $budgetPeriods,
  filter: ({ currentPeriodId }) => Boolean(currentPeriodId),
  fn: ({ currentPeriodId }) => ({
    query: {
      where: JSON.stringify({ periodId: currentPeriodId }),
      populate: JSON.stringify(['User', 'User.createdBy']),
    },
  }),
  target: [getBudgetListTeamFx, getBudgetListOwnFx],
})

sample({
  clock: decideRequestsBatchFx.doneData,
  target: reloadBudgetRequests,
})

sample({
  clock: enableEarlyPaymentFx.doneData,
  target: reloadBudgetRequests,
})

sample({
  clock: submitRequestsDelete,
  fn: ({ items }) => {
    const id = items[0].id
    return { url: `/budget/budget_request/${id}`, id }
  },
  target: deleteRequestsFx,
})

sample({
  clock: submitRequestsToSubmit,
  fn: ({ items }) => {
    const id = items[0].id
    return { url: `/budget/budget_request/${id}/submit`, id }
  },
  target: submitRequestFx,
})

sample({
  clock: submitRequestsReturnToDraft,
  fn: ({ items }) => {
    const id = items[0].id
    return { url: `/budget/budget_request/${id}/return_to_draft`, id }
  },
  target: returnToDraftRequestFx,
})

sample({
  clock: submitRequestEarlyPayment,
  fn: ({ id }) => ({
    url: `/budget/budget_request/${id}`,
    body: { isEarlyPayment: true as const },
  }),
  target: enableEarlyPaymentFx,
})

sample({
  clock: submitRequestsApprove,
  fn: ({ id, stepId, teamName, isFinal }) => {
    return {
      url: `/budget/budget_request/${id}/approval_step/${stepId}/approve`,
      id,
      stepId,
      teamName,
      isFinal,
    }
  },
  target: approveRequestsFx,
})

sample({
  clock: submitRequestsReject,
  fn: ({ id, stepId, teamName, comment }) => {
    return {
      url: `/budget/budget_request/${id}/approval_step/${stepId}/reject`,
      body: { comment },
      id,
      teamName,
    }
  },
  target: rejectRequestsFx,
})

sample({
  clock: submitRequestsApproveReject,
  fn: ({ id, comment }) => {
    return {
      url: `/budget/budget_request/${id}/reject_approved`,
      body: { comment },
      id,
    }
  },
  target: rejectApproveRequestsFx,
})

sample({
  clock: deleteRequestsFx.done,
  source: $budgetListOwnAll,
  fn: (budgetListOwn, { params }) => {
    if (!budgetListOwn) return null
    const { id } = params as { id: number }
    return budgetListOwn.filter((item) => item.id !== id)
  },
  target: $budgetListOwnAll,
})

sample({
  clock: [submitRequestFx.done, returnToDraftRequestFx.done],
  source: $budgetListOwnAll,
  fn: (budgetListOwn, { params, result }) => {
    if (!budgetListOwn) {
      return null
    }

    const { id } = params as { id: number }
    const { body } = result

    return budgetListOwn.map((item) => {
      if (item.id !== id) {
        return item
      }

      return { ...item, ...body }
    })
  },
  target: $budgetListOwnAll,
})

sample({
  clock: [
    approveRequestsFx.done,
    rejectRequestsFx.done,
    rejectApproveRequestsFx.done,
  ],
  source: $budgetListTeamAll,
  fn: (budgetListTeam, { params, result }) => {
    if (!budgetListTeam) {
      return null
    }
    const { id, stepId, isFinal } = params as {
      id: number
      stepId: number
      isFinal: boolean
    }
    const { body } = result

    return budgetListTeam.map((item) => {
      if (item.id !== id) {
        return item
      }

      return {
        ...item,
        ...body,
        availableApprovalSteps: isFinal
          ? []
          : item.availableApprovalSteps.filter((it) => it.id !== stepId),
      }
    })
  },
  target: $budgetListTeamAll,
})

sample({
  clock: addArticleItemFx.doneData,
  source: $accessibleArticles,
  fn: (
    accessibleArticles,
    { body: { articleId, id, number, fullNumber, name, description } },
  ) => {
    return accessibleArticles.map((article) =>
      article.id === articleId
        ? {
            ...article,
            items: [
              ...article.items,
              { id, number, fullNumber, name, description },
            ],
          }
        : article,
    )
  },
  target: $accessibleArticles,
})

// notifications

sample({
  clock: [
    getBudgetPeriodListFx.failData,
    getBudgetPeriodListForContextFx.failData,
    changeStatusBudgetPeriodFx.failData,
    getBudgetRequestByIdFx.failData,
    getBudgetListTeamFx.failData,
    getBudgetListOwnFx.failData,
    getRequestContextFx.failData,
    createRequestFx.failData,
    updateRequestFx.failData,
    enableEarlyPaymentFx.failData,
    returnToDraftRequestFx.failData,
    submitRequestFx.failData,
    copyBudgetRequestFx.failData,
    deleteRequestsFx.failData,
    approveRequestsFx.failData,
    rejectRequestsFx.failData,
    decideRequestsBatchFx.failData,
    postCommentRequestsFx.failData,
    getCommentsRequestsFx.failData,
    rejectApproveRequestsFx.failData,
    createPeriodFx.failData,
  ],
  fn: getBudgetErrorNotification,
  target: showNotification,
})

sample({
  clock: decideRequestsBatchFx.doneData,
  fn: ({ body }): NotificationPayload => ({
    type: body.failed.length === 0 ? 'success' : 'warning',
    description:
      body.failed.length === 0
        ? `Обработано заявок: ${body.succeeded.length}`
        : `Обработано: ${body.succeeded.length}. Не обработано: ${body.failed.length}`,
  }),
  target: showNotification,
})

sample({
  clock: createRequestFx.doneData,
  fn: ({ body }): NotificationPayload => {
    return {
      type: 'success',
      description: (
        <span>
          Новая заявка <strong>№{body.id}</strong> успешно сохранена в статусе{' '}
          {body.status && <strong>{STATUS_MAP_NAME[body.status]}</strong>}
        </span>
      ),
    }
  },
  target: showNotification,
})

sample({
  clock: returnToDraftRequestFx.doneData,
  fn: ({ body }): NotificationPayload => {
    return {
      type: 'success',
      description: (
        <span>
          Заявка <strong>№{body.id}</strong> успешно сохранена в статусе{' '}
          <strong>Черновик</strong>
        </span>
      ),
    }
  },
  target: showNotification,
})

sample({
  clock: updateRequestFx.doneData,
  fn: ({ body }): NotificationPayload => {
    return {
      type: 'success',
      description: (
        <span>
          Заявка <strong>№{body.id}</strong> успешно изменена
        </span>
      ),
    }
  },
  target: showNotification,
})

sample({
  clock: enableEarlyPaymentFx.doneData,
  fn: ({ body }): NotificationPayload => ({
    type: 'success',
    description: (
      <span>
        Для заявки <strong>№{body.id}</strong> запрошена досрочная оплата
      </span>
    ),
  }),
  target: showNotification,
})

sample({
  clock: submitRequestFx.doneData,
  fn: ({ body }): NotificationPayload => {
    return {
      type: 'success',
      description: (
        <span>
          Заявка <strong>№{body.id}</strong> успешно переведена в статус{' '}
          <strong>На согласовании</strong>
        </span>
      ),
    }
  },
  target: showNotification,
})

sample({
  clock: deleteRequestsFx.done,
  fn: ({ params, result }): NotificationPayload => {
    const { id } = params as { id: string }
    return {
      type: 'success',
      description: (
        <span>
          Заявка <strong>№{id}</strong> успешно <strong>удалена</strong>
        </span>
      ),
    }
  },
  target: showNotification,
})

sample({
  clock: rejectRequestsFx.done,
  fn: ({ params }): NotificationPayload => {
    const { id, teamName, isFinal } = params as {
      id: string
      teamName: string
      isFinal: boolean
    }
    return {
      type: 'success',
      description: (
        <span>
          Заявка{' '}
          <strong>
            №{id}: ${teamName}
          </strong>{' '}
          успешно {isFinal ? 'финально' : ''} <strong>отклонена</strong>
        </span>
      ),
    }
  },
  target: showNotification,
})

sample({
  clock: approveRequestsFx.done,
  fn: ({ params }): NotificationPayload => {
    const { id, teamName, isFinal } = params as {
      id: string
      teamName: string
      isFinal: boolean
    }
    return {
      type: 'success',
      description: (
        <span>
          Заявка{' '}
          <strong>
            №{id}: {teamName}
          </strong>{' '}
          успешно {isFinal ? 'финально' : ''} <strong>согласована</strong>
        </span>
      ),
    }
  },
  target: showNotification,
})

sample({
  clock: rejectApproveRequestsFx.done,
  fn: ({ params }): NotificationPayload => {
    const { id } = params as { id: string }
    return {
      type: 'success',
      description: (
        <span>
          Заявка <strong>№{id}</strong> успешно <strong>отклонена: SEO</strong>
        </span>
      ),
    }
  },
  target: showNotification,
})

sample({
  clock: createPeriodFx.doneData,
  fn: (params): NotificationPayload => {
    const { body } = params
    const period = capitalize(
      dayjs(body?.periodFormatted, 'YYYY-MM').format('MMMM YYYY'),
    )
    const status = body?.status as TStatusPeriod
    return {
      type: 'success',
      description: (
        <span>
          Бюджетный период <strong>{period}</strong> успешно создан в статусе{' '}
          <strong>{STATUS_PERIOD_LABELS[status]}</strong>
        </span>
      ),
    }
  },
  target: showNotification,
})

sample({
  clock: changeStatusBudgetPeriodFx.doneData,
  fn: (params): NotificationPayload => {
    const status = params?.body?.status as TStatusPeriod
    return {
      type: 'success',
      description: (
        <span>
          Бюджетный период успешно переведен в статус{' '}
          <strong>{STATUS_PERIOD_LABELS[status]}</strong>
        </span>
      ),
    }
  },
  target: showNotification,
})

sample({
  clock: postCommentRequestsFx.doneData,
  fn: (params): NotificationPayload => {
    const id = params?.body?.entityId
    ;('')
    return {
      type: 'success',
      description: (
        <span>
          Комментарий к бюджетной заявке <strong>№{id}</strong> успешно
          отправлен
        </span>
      ),
    }
  },
  target: showNotification,
})
